export default [
  {
    label: 'IRPJ',
    key: 'Irpj',
    tooltip: 'Imposto de Renda da Pessoa Jurídica, devido sobre o lucro das empresas.',
  },
  {
    label: 'CSLL',
    key: 'Csll',
    tooltip: 'Contribuição Social sobre o Lucro Líquido, calculada sobre o resultado ajustado da empresa.',
  },
  {
    label: 'IRRF',
    key: 'Irrf',
    tooltip: 'Imposto de Renda Retido na Fonte, recolhido diretamente de pagamentos a terceiros.',
  },
  {
    label: 'IPI',
    key: 'Ipi',
    tooltip: 'Imposto sobre Produtos Industrializados, incidente na fabricação e importação.',
  },
  {
    label: 'IOF',
    key: 'Iof',
    tooltip: 'Imposto sobre Operações Financeiras, aplicado em crédito, câmbio, seguros e investimentos.',
  },
  {
    label: 'PIS/PASEP',
    key: 'PisPasep',
    tooltip: 'Contribuições sociais destinadas ao financiamento da seguridade social.',
  },
  {
    label: 'COFINS',
    key: 'Cofins',
    tooltip: 'Contribuição para o Financiamento da Seguridade Social, cobrada sobre receitas.',
  },
  {
    label: 'Contribuições Diversas',
    key: 'ContribuicoesDiversas',
    tooltip: 'Outros tributos e encargos específicos de determinados setores ou situações.',
  },
  {
    label: 'CPSS',
    key: 'Cpss',
    tooltip: 'Contribuição Previdenciária dos Servidores Públicos.',
  },
  {
    label: 'Ret/Pagamento Unificado',
    key: 'RetPagamentoUnificado',
    tooltip: 'Valores retidos ou recolhidos em regime de apuração consolidada.',
  },
]
